import React, { useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText } = FiIcons;

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 py-16 px-6">
      <div className="max-w-3xl mx-auto bg-slate-900 rounded-2xl shadow-2xl border border-slate-800 p-8 md:p-12">
        <div className="flex items-center gap-4 mb-8 border-b border-slate-800 pb-6">
          <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center">
            <SafeIcon icon={FiFileText} className="text-blue-500 text-2xl" />
          </div>
          <h1 className="text-3xl font-bold text-white">Términos y Condiciones</h1>
        </div>

        <div className="space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Propósito de la herramienta</h2>
            <p>ProtegeTuRed by ComplianceBOX es una herramienta de autodiagnóstico diseñada con fines exclusivamente educativos e informativos. Su objetivo es ayudar a las organizaciones a identificar áreas generales de mejora en su postura de ciberseguridad basada en las respuestas proporcionadas por el usuario.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Exención de responsabilidad</h2>
            <p>Al utilizar esta herramienta, usted comprende y acepta explícitamente que:</p>
            <ul className="list-disc pl-5 mt-2 space-y-2 text-slate-400">
              <li>Los resultados, puntajes y recomendaciones generados <strong>no constituyen una auditoría oficial</strong>, certificación, ni asesoría legal o técnica formal.</li>
              <li>La herramienta no garantiza el cumplimiento de ninguna normativa, ley o estándar de la industria (como ISO 27001, SOC 2, HIPAA, GDPR, etc.).</li>
              <li>ComplianceBOX y sus afiliados no asumen ninguna responsabilidad por incidentes de seguridad, brechas de datos, daños cibernéticos, multas o pérdidas operativas que puedan ocurrir antes, durante o después del uso de esta herramienta, independientemente de si se han seguido o no las recomendaciones proporcionadas en el reporte.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Uso aceptable</h2>
            <p>Usted se compromete a utilizar esta herramienta de buena fe, proporcionando información veraz sobre su propia organización o aquella que esté autorizado a representar. Queda estrictamente prohibido utilizar esta plataforma para intentar realizar evaluaciones de infraestructuras de terceros sin su consentimiento explícito y por escrito.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Propiedad Intelectual</h2>
            <p>Todo el contenido, diseño gráfico, cuestionarios, algoritmos de puntuación, metodologías y estructura de los reportes generados son propiedad intelectual exclusiva de ComplianceBOX. Queda prohibida su reproducción, distribución, modificación o uso comercial sin autorización previa y por escrito de nuestra parte.</p>
          </section>
          
          <section className="pt-6 border-t border-slate-800">
            <h2 className="text-xl font-bold text-white mb-3">5. Contacto y Soporte</h2>
            <p>Para dudas sobre estos términos y condiciones, o para solicitar información sobre servicios formales de consultoría, por favor contáctenos en: <a href="mailto:hello@compliancebox.org" className="text-blue-400 hover:text-blue-300 transition-colors font-medium">hello@compliancebox.org</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}